import type { GraphQLError } from 'graphql';

export class Error404 extends Error {
	constructor(error: GraphQLError | string) {
		super(typeof error === 'string' ? error : error.message, { cause: error });
	}
}
